import * as React from "react";

;
export const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="m8.06 12 8.47 8.47-1.06 1.06L5.94 12l9.53-9.53 1.06 1.06L8.06 12Z" /></svg>;